import React, { useState } from 'react';
import styled from 'styled-components';
import { TitleContainer, ActionButton, SettingsLabel, OrganisationCheckbox } from './components/AccountDetailsComponents';
import AddEmailContact from './AddEmailContact';

const EmailContactList = ({ emailContacts, onChange, disabled }) => {
  const [isAddingEmailContact, setIsAddingEmailContact] = useState(false);

  const toggleIsAddingEmailContact = () => setIsAddingEmailContact(prevIsAddingEmailContact => !prevIsAddingEmailContact);

  const addEmailContactChangeHandler = email => checked => {
    if (!(checked || window.confirm(`Do you want to delete this email? ${email}`))) return;
    onChange(email, checked);
  };

  const addEmailHandler = email => {
    onChange(email, true);
    toggleIsAddingEmailContact();
  };

  return (
    <>
      <SettingsLabel>
        <TitleContainer>Email Contacts</TitleContainer>
        <ActionButton disabled={disabled} onClick={toggleIsAddingEmailContact}>
          {isAddingEmailContact ? 'Cancel' : 'Add Email Contact'}
        </ActionButton>
      </SettingsLabel>
      <Container>
        {isAddingEmailContact && (
          <AddEmailContact
            onSubmit={addEmailHandler}
            onCancel={toggleIsAddingEmailContact}
          />
        )}
        {emailContacts &&
          emailContacts.map(email => (
            <OrganisationCheckbox
              disabled={disabled}
              checked
              key={email}
              onChange={addEmailContactChangeHandler(email)}
            >
              {email}
            </OrganisationCheckbox>
          ))}
      </Container>
    </>
  );
};

const Container = styled.div`
  overflow-y: auto;
  max-height: 300px;
`;

export default EmailContactList;
